import { Box, Typography } from '@mui/material';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { AdcashAdfitRevenueItem } from '../../../types/adcash.types';

const REVENUE_COLOR = '#64B5F6';
const REVENUE_GRADIENT_ID = 'colorAdfitRevenue';

type Props = {
  data: AdcashAdfitRevenueItem[];
};

export default function AdfitRevenueDashboard({ data }: Props) {
  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderRadius: 3,
        p: 3,
        mt: 3,
        border: '1px solid #f1f5f9',
      }}
    >
      <Typography
        variant="subtitle1"
        fontWeight={600}
        mb={2}
        textAlign="center"
        color="#475569"
      >
        일별 매출 추이
      </Typography>
      <ResponsiveContainer width="100%" height={280}>
        <AreaChart data={data} margin={{ top: 8, right: 24, left: 8, bottom: 8 }}>
          <defs>
            <linearGradient id={REVENUE_GRADIENT_ID} x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={REVENUE_COLOR} stopOpacity={0.25} />
              <stop offset="95%" stopColor={REVENUE_COLOR} stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" vertical={false} />
          <XAxis dataKey="date" tick={{ fontSize: 12 }} />
          <YAxis
            tickFormatter={(v) =>
              v >= 10000 ? `${(v / 10000).toFixed(0)}만` : v.toLocaleString('ko-KR')
            }
            tick={{ fontSize: 11 }}
            label={{ value: '매출', angle: -90, position: 'insideLeft', style: { fontSize: 12 } }}
          />
          <Tooltip
            content={({ active, payload }) => {
              if (!active || !payload?.length) return null;
              const row = payload[0]?.payload as AdcashAdfitRevenueItem;
              if (!row) return null;
              return (
                <Box
                  sx={{
                    p: 1.5,
                    minWidth: 160,
                    bgcolor: 'background.paper',
                    borderRadius: 1,
                    border: '1px solid',
                    borderColor: 'divider',
                    boxShadow: 2,
                  }}
                >
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: 600 }}>
                    {row.date}
                  </Typography>
                  <Typography variant="body2">
                    매출: ₩{row.revenue.toLocaleString('ko-KR', { maximumFractionDigits: 0 })}
                  </Typography>
                </Box>
              );
            }}
          />
          <Area
            type="monotone"
            dataKey="revenue"
            stroke={REVENUE_COLOR}
            strokeWidth={2}
            fill={`url(#${REVENUE_GRADIENT_ID})`}
            fillOpacity={1}
            name="매출"
          />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  );
}
